module.exports = __webpack_public_path__ + "img/subscribe.77ce6ea0.png";